export default __webpack_public_path__ + "static/media/keyboard-red.625456f8.jpg";